import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import shallowCompare from 'react-addons-shallow-compare';

// -- stores
import SessionStore from 'stores/SessionStore';

import MenuAbstracComponent from '../AbstractMenuComponent';

/**
 * Display a sidebar
 *
 * User metisMenu jquery library to handle sub-menus.
 *
 * @parent Layout
 *
 * Handle the header view.
 * Responsive mode: Hidden. The header will display the same content.
 */
class Sidebar extends MenuAbstracComponent {
  static propTypes = {};

  shouldComponentUpdate(nextProps, nextState) {
    return true;
    // return shallowCompare(this, nextProps, nextState);
  }

  render(): Object {
    /**
     * TODO: Add 'active' class to the current route.
     */

    if (!SessionStore.isLoggedIn()) {
      return null;
    }

    return (
      <nav role="navigation">
        <ul className="nav nav-sidebar navbar-collapse">
          {this.renderDashboard()}
          {this.renderOrder()}
          {this.renderPayment()}
          {this.renderRestaurantSettings()}
        </ul>
      </nav>
    );
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./scripts/components/sidebar/Sidebar.js